import React, {useEffect, useRef} from "react";
import MainInfo from "./components/MainInfo/MainInfo";
import Vertical from "./components/Vertical/Vertical";
import Description from "./components/Description/Description";
import DataSecurity from "./components/DataSecurity/DataSecurity";
import Rating from "./components/Rating/Rating";
import ContactDeveloper from "./components/ContactDeveloper/ContactDeveloper";
import ClipLoader from "react-spinners/ClipLoader";
import {IPwaData} from "./interfaces";
import {CookieBanner} from "./components/CookieBanner";
import DescriptionModal from "./components/DescriptionModal/DescriptionModal";
import "./styles/global.scss";

type IDuckSayPWA = {
    pwaData?: IPwaData;
    testPwaDomain?: string;
    isMockPWA?: boolean;
    isPreview?: boolean;
    loading?: boolean;
    currentGeo?: string;
    ip?: string;
    onInstallCallback?: () => void;
    xRequestedWith?: string;
};

const PWA: React.FC<IDuckSayPWA> = ({
    pwaData: pwa,
    testPwaDomain,
    loading,
    currentGeo,
    ip,
    onInstallCallback,
    xRequestedWith
}) => {
    const [defferedPrompt, setDeferredPrompt] = React.useState<any>(null);
    const [isDescriptionModalOpen, setIsDescriptionModalOpen] = React.useState<boolean>(false);

    useEffect(() => {
        const handleBeforeInstallPrompt = (e: Event) => {
            e.preventDefault();
            console.log("before install prompt", e);
            setDeferredPrompt(e);
        };

        window.addEventListener("beforeinstallprompt", handleBeforeInstallPrompt);

        return () => {
            window.removeEventListener("beforeinstallprompt", handleBeforeInstallPrompt);
        };
    }, []);

    useEffect(() => {
        if (defferedPrompt) {
            console.log("Deferred Prompt is set:", defferedPrompt);
        }
    }, [defferedPrompt]);
    return (
        <>
            {!loading ? (
                <>
                    <div className="container">
                        {pwa && (
                            <>
                                <MainInfo
                                    defferedPrompt={defferedPrompt}
                                    setDefferedPrompt={setDeferredPrompt}
                                    pwa={pwa}
                                    testPwaDomain={testPwaDomain}
                                    currentGeo={currentGeo}
                                    ip={ip}
                                    onInstallCallback={onInstallCallback}
                                    xRequestedWith={xRequestedWith}
                                />
                                <div className="wrapper">
                                    <div className="grid-container">
                                        <div className="grid-item item-large">
                                            <div className="pb-16">
                                                <Vertical pwa={pwa}/>
                                            </div>
                                            <div className="pb-16">
                                                <Description pwa={pwa}
                                                             setIsDescriptionModalOpen={setIsDescriptionModalOpen}/>
                                            </div>
                                            <div className="pb-16">
                                                <DataSecurity pwa={pwa}/>
                                            </div>
                                            <div className="pb-16">
                                                <Rating pwa={pwa}/>
                                            </div>
                                        </div>
                                        <div className="grid-item item-small">
                                            <ContactDeveloper pwa={pwa}/>
                                        </div>
                                    </div>
                                </div>
                            </>
                        )}
                    </div>
                    {pwa?.filesCookies ? <CookieBanner/> : null}
                </>
            ) : (
                <div className={"loader-cover"}>
                    <ClipLoader
                        color={"#0e77c2"}
                        loading={true}
                        // cssOverride={override}
                        size={150}
                        aria-label="Loading Spinner"
                        data-testid="loader"
                    />
                </div>
            )}
            {isDescriptionModalOpen &&
                <DescriptionModal pwa={pwa} setIsDescriptionModalOpen={setIsDescriptionModalOpen}/>}
        </>
    );
};

export default PWA;
